function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDropdown = function SvgDropdown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 163 131",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.84404,0,0,1.53664,-98.3462,-30.9251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.88,24.409C88.139,24.409 89.614,24.409 89.614,24.409",
    style: {
      fill: "rgb(44,145,248)",
      stroke: "rgb(0,129,198)",
      strokeWidth: "5.47px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.84404,0,0,1.53664,-96.5696,28.0693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.248,24.409L88.982,24.409",
    style: {
      fill: "rgb(44,145,248)",
      stroke: "rgb(0,129,198)",
      strokeWidth: "5.47px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.84404,0,0,1.53664,-94.7929,87.0637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.615,24.409C86.874,24.409 88.35,24.409 88.35,24.409",
    style: {
      fill: "rgb(44,145,248)",
      stroke: "rgb(0,129,198)",
      strokeWidth: "5.47px"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropdown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dropdown.6df0afec.svg";
export { ForwardRef as ReactComponent };